import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import Gender from "../Shared/Gender";
import MaritalStatus from "@/models/Shared/MaritalStatus";
import WorkType from "@/models/Shared/WorkType";

export default class UpdateWorkerGeneralDetailsRequest extends BaseUpdateRequest {
    legacyId: string;
    mobilePhoneNumber: string;
    otherPhoneNumber: string;
    emailAddress: string;     
	dateOfBirth: string;               
	gender: Gender;                 
	maritalStatus: MaritalStatus;           
	nationality: string;          
    workTypes: WorkType[]
    isDriver: boolean;
    isAgreedToMarketing: boolean;
    defaultBranchId: string;
    defaultDeskId: string;
}